import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class StudentSportsDetails {   
  PreStudentSportsID:number; 
  StudentID:number; 
  AcademicInstanceID:number; 
  ExamInstanceID:number; 
  SpNmID:number; 
  LevelID:number; 
  SpName:string;
  LevelName:string;
  Year:number; 
  Description:string; 
  CertificateDoc:string; 
  DeleteFlag:number; 
  CreatedLoginID:number;  
  UpdatedLoginID:number;  
}
export class SportsDetails {   
  SpNmID:number; 
  SpName:string;    
}
export class LevelDetails {   
  LevelID:number; 
  LevelName:string;    
}
@Injectable({
  providedIn: 'root'
})

export class StudentSportsDtlService {
    constructor(private dataService: DataAccessService) { }
    public StudentSportsDtlServiceData: StudentSportsDtlService;
    
  public GetPreStudentSportsByStudentId(StudentID,PreStudentSportsID) {
    this.dataService.setControllerName = '/PreStudentSports/';
    this.dataService.setMethodName = 'GetPreStudentSportsByStudentId?StudentID='+ StudentID +'&PreStudentSportsID='+PreStudentSportsID + ""; // setting method name from API controller.
    return this.dataService.getAll<StudentSportsDetails[]>()
  } 
  public GetBasicSportNamesByID(SpNmID) {
    this.dataService.setControllerName = '/BasicSportNames/';
    this.dataService.setMethodName = 'GetBasicSportNamesListByID?SpNmID='+ SpNmID + ""; // setting method name from API controller.
    return this.dataService.getAll<SportsDetails[]>()
  } 
  public GetBasicLevelListByID(LevelID,LevelType) {
    this.dataService.setControllerName = '/BasicLevel/';
    this.dataService.setMethodName = 'GetBasicLevelListByID?LevelID='+ LevelID + "&LevelType=" + LevelType + ""; // setting method name from API controller.
    return this.dataService.getAll<LevelDetails[]>()
  } 
  
  public GetPersonalInformation(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationListByID?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<StudentSportsDetails[]>()
  } 
  
  public PostInsertPreStudentSports(data) {debugger
    this.dataService.setControllerName = '/PreStudentSports/';
    this.dataService.setMethodName = 'PostInsertPreStudentSports'; 
    return this.dataService.add<StudentSportsDetails[]>(data) 
  }
  public PostPreStudentSports(data) {debugger
    this.dataService.setControllerName = '/PreStudentSports/';
    this.dataService.setMethodName = 'PostPreStudentSports'; 
    return this.dataService.add<StudentSportsDetails[]>(data) 
  }
  public PostDeletePreStudentSports(data) {debugger
    this.dataService.setControllerName = '/PreStudentSports/';
    this.dataService.setMethodName = 'PostDeletePreStudentSports'; 
    return this.dataService.add<StudentSportsDetails[]>(data) 
  }
  public PostRemovedSportsCertificate(data) {debugger
    this.dataService.setControllerName = '/PreStudentSports/';
    this.dataService.setMethodName = 'PostRemovedSportsCertificate'; 
    return this.dataService.add<StudentSportsDetails[]>(data) 
  }
}
